import { Workday } from '@/api/workday';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';

import WorkdayId from './WorkdayInput';

export const getColumns = (
	handleInputChange: (
		key: string,
		field: keyof Workday,
		value: any,
		row: Workday,
	) => void,
	handleSaveRow: (key: string) => void,
	updateData: Record<string, Workday>,
): ColumnDef<Workday>[] => [
	{
		accessorKey: 'userId',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				AIM User Id
			</Button>
		),
		cell: ({ row }) => <div>{row.original.userId}</div>,
	},
	{
		accessorKey: 'username',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				User Name
			</Button>
		),
		cell: ({ row }) => <div>{row.original.username}</div>,
	},
	{
		accessorKey: 'workdayId',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Workday Id
			</Button>
		),
		cell: ({ row }) => {
			const stableKey = `${row.original.id}-${row.original.aimInstance}`;
			return (
				<WorkdayId
					row={row.original}
					updateData={updateData}
					stableKey={stableKey}
					handleInputChange={handleInputChange}
				/>
			);
		},
	},
	{
		accessorKey: 'addDate',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Date Added
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div>
					{row.original.addDate ? format(row.original.addDate, 'P') : '---'}
				</div>
			);
		},
	},
	{
		accessorKey: 'modDate',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Date Modified
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div>
					{row.original.modDate ? format(row.original.modDate, 'P') : '---'}
				</div>
			);
		},
	},
	{
		accessorKey: 'aimInstance',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				AIM Instance
			</Button>
		),
		cell: ({ row }) => <div>{row.original.aimInstance}</div>,
	},
	{
		accessorKey: 'activeFlag',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Active Flag
			</Button>
		),
		cell: ({ row }) => (
			<div>{row.original.activeFlag === 'Y' ? 'Yes' : 'No'}</div>
		),
	},
	{
		accessorKey: 'ignore',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Ignore
			</Button>
		),
		cell: ({ row }) => {
			const stableKey = `${row.original.id}-${row.original.aimInstance}`;
			return (
				<Switch
					checked={updateData[stableKey]?.ignore ?? row.original.ignore}
					onCheckedChange={(checked) => {
						handleInputChange(stableKey, 'ignore', checked, row.original);
					}}
					className="transition-colors duration-200 data-[state=checked]:bg-blue-500 data-[state=unchecked]:bg-gray-300"
				/>
			);
		},
	},
	{
		accessorKey: 'actions',
		header: 'Actions',
		cell: ({ row }) => {
			const stableKey = `${row.original.id}-${row.original.aimInstance}`;
			return (
				<>
					<Button
					className="bg-blue-500 text-white"
					onClick={() => handleSaveRow(stableKey)}
					disabled={!updateData[stableKey]}
					>
						Save
					</Button>
				</>
			);
		},
	},
];
